import {Routes} from '@angular/router';
import {LandingComponent} from './pages/landing/landing.component';
import {PhotographerComponent} from './pages/photographer/photographer.component';
import {BookingCreateComponent} from './pages/booking-create/booking-create.component';
import {BookingCreateSuccessComponent} from './pages/booking-create-success/booking-create-success.component';
import {BookingCreateCancelComponent} from './pages/booking-create-cancel/booking-create-cancel.component';
import {MyAccountComponent} from './pages/my-account/my-account.component';
import {MyDiscountsComponent} from './pages/my-discounts/my-discounts.component';
import {AuthGuard} from '../core/guards/auth.guard';
import {BookingPhotosComponent} from './pages/booking-photos/booking-photos.component';
import {GiftCardComponent} from './pages/gift-card/gift-card.component';
import {GiftCardConfirmationComponent} from './pages/gift-card-confirmation/gift-card-confirmation.component';

export const routes: Routes = [
  { path: '', component: LandingComponent},
  { path: 'photographer/:slug', component: PhotographerComponent},
  { path: 'photographer/:slug/:service/book', component: BookingCreateComponent},
  { path: 'photographer/:slug/:service/book/:id/success', component: BookingCreateSuccessComponent},
  { path: 'photographer/:slug/:service/book/:id/cancel', component: BookingCreateCancelComponent},
  { path: 'gift-card/payment/:status', component: GiftCardConfirmationComponent},
  { path: 'gift-card', component: GiftCardComponent},
  { path: 'my-account', component: MyAccountComponent, canActivate: [AuthGuard]},
  { path: 'my-discounts', component: MyDiscountsComponent, canActivate: [AuthGuard]},
  { path: 'my-account/booking/:id/photos', component: BookingPhotosComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: ''}
];
